import { Controller } from '@hotwired/stimulus'
import type { App } from 'vue'

import { abort } from '@app/adapters/abort'
import { createApp } from '@app/adapters/create-app'
import { SfLog } from '@app/adapters/logger'
import {
  UNMOUNTED_USERS_REQUEST_REASON,
  USERS_REQUEST_KEY,
} from '@app/application/user-management/constants'
import { isUserList } from '@app/application/user-management/predicates'
import UsersList from '@app/application/user-management/components/users-list.vue'

export default class extends Controller {
  static values = { list: String }

  declare listValue: string
  private app?: App

  connect(): void {
    // The list picks the endpoint, so an unknown one would quietly serve the
    // external users on the staff page.
    if (!isUserList(this.listValue)) {
      SfLog.warn('users-table mount is missing a known list', {
        extra: { list: this.listValue },
      })

      return
    }

    this.app?.unmount()
    this.app = createApp(UsersList, { list: this.listValue })
    this.app.mount(this.element)
  }

  disconnect(): void {
    // Unmounting Vue leaves the request the list has in flight running, and it
    // answers into a store that nothing renders.
    abort(USERS_REQUEST_KEY, UNMOUNTED_USERS_REQUEST_REASON)
    this.app?.unmount()
    this.app = undefined
  }
}
